/**
 * Blob データをファイルとしてダウンロード
 *
 * @param blob - ダウンロードするデータ
 * @param filename - ファイル名
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    window.URL.revokeObjectURL(url)
  }
}

/**
 * Content-Disposition ヘッダーからファイル名を抽出
 *
 * @param contentDisposition - Content-Disposition ヘッダー値
 * @param defaultFilename - デフォルトファイル名
 * @returns 抽出されたファイル名、または defaultFilename
 */
export const extractFilenameFromHeader = (
  contentDisposition: string | null | undefined,
  defaultFilename: string
): string => {
  if (!contentDisposition) return defaultFilename

  const filenameMatch = contentDisposition.match(
    /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  )
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].replace(/['"]/g, '')
  }

  return defaultFilename
}

/**
 * 現在日付を含むファイル名を生成
 *
 * @param prefix - ファイル名のプレフィックス
 * @param extension - ファイル拡張子（ドットなし）
 * @returns 生成されたファイル名（例: "metrics_2025-12-21.csv"）
 */
export const generateDateFilename = (
  prefix: string,
  extension: string
): string => {
  const date = new Date().toISOString().split('T')[0]
  return `${prefix}_${date}.${extension}`
}
